import { defineMessages, useIntl } from 'react-intl';
import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';

import { DEFAULT_SHIPMENTS_PAGE_URL } from '../../../services/user-permission-service';
import AdvancedHotkey from './component';

export const messages = defineMessages({
  name: {
    description: 'navigationHotkeys.ShipmentsPage',
    defaultMessage: 'Shipments',
    id: '2VqaRk',
  },
});

export const hotkey = ['g', 's'];
export const barcodeContent = '+5ELMF5XDAPPE=';

const GotoShipmentsPage = ({ children }) => {
  const intl = useIntl();
  const history = useHistory();
  const handler = useCallback(() => history.push(DEFAULT_SHIPMENTS_PAGE_URL), [history]);
  const hotkeyMetadata = useMemo(
    () => ({
      barcode: barcodeContent,
      displayHotkeyStrings: ['gs'],
      hotkey,
      handler,
      name: intl.formatMessage(messages.name),
      legacyCategory: 'navigation',
      isGlobal: true,
    }),
    [intl, handler],
  );

  return <AdvancedHotkey hotkey={hotkeyMetadata}>{children}</AdvancedHotkey>;
};

GotoShipmentsPage.propTypes = {
  children: PropTypes.node.isRequired,
};

export default GotoShipmentsPage;
